<template>
  <div class="send-mail-templates">
    <div class="button-wrap" v-if="!mixinSortModeFlg">
      <base-button-register
        :text="'定型文登録'"
        v-if="lookOnlyFlg === 0"
        @click="pushToSendMailTemplateNew"
      />
      <base-sort-button
        class="button"
        v-if="lookOnlyFlg === 0"
        @click="setSortMode"
      />
    </div>
    <div class="button-wrap" v-else>
      <base-button-small-white class="button" @click="cancelSortMode"
        >キャンセル</base-button-small-white
      >
      <base-button-small-orange
        class="button"
        v-if="lookOnlyFlg === 0"
        @click="updateOrder"
        :disabled="waitFlg"
        >並び順登録</base-button-small-orange
      >
    </div>
    <div class="list-wrap">
      <div class="heading">
        定型文一覧<span v-if="mixinSortModeFlg">{{
          mixinSortModeMessage
        }}</span>
      </div>
      <list-table
        :headerData="headers"
        :propertyData="properties"
        :bodyData="displaySendMailTemplates"
        :sortModeFlg="mixinSortModeFlg"
        @click="pushToSendMailTemplateShow"
        @order="changeOrder"
      />
    </div>
    <announce-popup
      v-if="mixinSortPopup.showFlg"
      :type="mixinSortPopup.type"
      :title="mixinSortPopup.title"
      :buttons="mixinSortPopup.buttons"
      @close="mixinCloseSortPopup"
      >{{ mixinSortPopup.message }}</announce-popup
    >
    <unsaved-leave-popup />
  </div>
</template>

<script>
import BaseButtonRegister from '@/components/parts/atoms/BaseButtonRegister'
import BaseSortButton from '@/components/parts/atoms/BaseSortButton'
import BaseButtonSmallWhite from '@/components/parts/atoms/BaseButtonSmallWhite'
import BaseButtonSmallOrange from '@/components/parts/atoms/BaseButtonSmallOrange'
import ListTable from '@/components/parts/organisms/ListTable.vue'
import AnnouncePopup from '@/components/popups/AnnouncePopup'
import UnsavedLeavePopup from '@/components/popups/UnsavedLeavePopup'
import ApiOrder from '@/components/mixins/ApiOrder'
import CheckInputDifference from '@/components/mixins/CheckInputDifference'
import { mapGetters } from 'vuex'

export default {
  name: 'SendMailTemplates',

  components: {
    BaseButtonRegister,
    BaseSortButton,
    BaseButtonSmallWhite,
    BaseButtonSmallOrange,
    ListTable,
    AnnouncePopup,
    UnsavedLeavePopup
  },

  mixins: [ApiOrder, CheckInputDifference],

  data() {
    return {
      headers: ['標準', '定型文名'],
      properties: ['order', 'name'],
      waitFlg: false
    }
  },

  computed: {
    ...mapGetters({
      sendMailTemplates: 'sendMailTemplates/getData',
      lookOnlyFlg: 'auth/lookOnlyFlg'
    }),
    displaySendMailTemplates() {
      return this.mixinSortModeFlg
        ? this.mixinInputData
        : this.sendMailTemplates
    }
  },

  watch: {
    mixinSortModeFlg: function() {
      this.setData()
    }
  },

  created() {
    this.setData()
  },

  methods: {
    setData() {
      this.mixinInputData = this.sendMailTemplates
      this.mixinSetInitialData()
    },
    pushToSendMailTemplateNew() {
      this.$router.push({ name: 'send-mail-template-new' })
    },
    pushToSendMailTemplateShow(id) {
      this.$router.push({ name: 'send-mail-template-show', params: { id } })
    },
    setSortMode() {
      this.mixinSortModeFlg = true
    },
    cancelSortMode() {
      this.mixinSortModeFlg = false
    },
    changeOrder(data) {
      this.mixinInputData = data.map(v1 =>
        this.mixinInputData.find(v2 => v2.id === v1.id)
      )
    },
    async updateOrder() {
      this.waitFlg = true
      await this.mixinUpdateOrder('sendMailTemplates', this.mixinInputData)
      if (this.mixinSortSucceeded) this.mixinSetInitialData()
      this.waitFlg = false
    }
  }
}
</script>

<style lang="scss" scoped>
.send-mail-templates {
  > .button-wrap {
    display: flex;
    justify-content: flex-end;
    > .button {
      margin-left: 20px;
    }
  }
  > .list-wrap {
    margin-top: 16px;
    ::v-deep .list-table .table-body {
      max-height: 560px;
    }
    > .heading {
      margin-bottom: 16px;
      font-size: 15px;
      font-weight: bold;
    }
  }
}
</style>
